<template lang="pug">
  .text-field-width-icon
    icon(:name="name" class="icon-input-type")

    input(
      :type="type"
      :name="name"
      :value="value"
      :placeholder="placeholder"
      :autocomplete="autocomplete"
      :required="required"
      @input="$emit('input', $event.target.value)"
      @keydown.space="disable"
    )
</template>

<style lang="scss" scoped>
.text-field-width-icon {
  background-color: rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
}

.icon-input-type {
  position: absolute;
  margin-left: 17px;
}

input {
  height: 56px;
  width: 100%;
  @extend %input-text;
  text-indent: 52px;

  @include placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
}
</style>

<script>
export default {
  props: {
    value: { type: String },
    type: { type: String, default: 'text' },
    name: { type: String, required: true },
    placeholder: { type: String },
    autocomplete: { type: String, default: 'off' },
    required: { type: Boolean, default: true },
  },
  methods: {
    disable(e) {
      if (this.type === 'email') {
        e.preventDefault()
      }
    },
  },
}
</script>
